import { HomepageTermsAndConditionsType } from "@services/HomepageTermsAndConditions.services";

export const MAIN_CURRENCY = "bfusd";
export const MAIN_CURRENCY_LABEL = "usdt";
export const ENHANCED_MARKET = ["US", "PR", "VI"]; // us_investor
export const DEFAULT_TIMELOCK_STAKING_MIN_VALUE = 5000;

export const TwoFAPinLength = 6;

export const mainCurrencies = [MAIN_CURRENCY, "usdt"];

export const BFID_URL = process.env.BF_IDENTITY_URL;
export const WORDPRESS_URL = process.env.WORDPRESS_DOMAIN;

export const rootUrl = process.env.BF_APP_URL;

export const BWBRedirectUrl = "https://www.simondixon.com/bwb";
export const UkBWBRedirectUrl = "https://www.bitcoinwealthbuilder.io/bwb ";

export const DESKTOP_WIDTH = 1026;

export enum AccountTier {
  Tier_0 = "tier_0",
  Tier_0_KYC = "tier_0_kyc",
  Tier_1_UK_restricted = "tier_1_uk_restricted",
  Tier_1 = "tier_1",
  Tier_2 = "tier_2",
  Tier_3 = "tier_3",
  Tier_4 = "tier_4",
}

// order is important
export const AgreementsConfig: {
  [key: string]: {
    key: string;
    label: string;
    section_name: string;
    private: boolean;
    active: boolean;
  };
} = {
  global: {
    key: "1",
    label: "BF Platform Operator",
    section_name: "BF Platform Operator",
    private: false,
    active: true,
  },
  virtual_assets: {
    key: "3",
    label: "BF Virtual Asset Broker",
    section_name: "BF Virtual Asset Broker",
    private: false,
    active: true,
  },
  securities: {
    key: "2",
    label: "BF Securities Broker",
    section_name: "BF Securities Broker",
    private: false,
    active: true,
  },
  staking: {
    key: "4",
    label: "Staking Terms",
    section_name: "Staking",
    private: true,
    active: true,
  },
  auto_invest: {
    key: "6",
    label: "Auto-Invest Terms",
    section_name: "Auto-Invest",
    private: true,
    active: false,
  },
  portfolio_builder: {
    key: "5",
    label: "Portfolio Builder Terms",
    section_name: "Portfolio Builder",
    private: true,
    active: true,
  },
  us_terms: {
    key: "7",
    label: "US Investors Terms",
    section_name: "US Investors",
    private: true,
    active: true,
  },
};

export const HomepageAgreementsConfig: HomepageTermsAndConditionsType[] = [
  "risk_warnings",
  "privacy_cookies",
];
